import { customCurrencyChanger } from 'helpers/utils';

function formatPoints(valor) {
  return Number.isInteger(valor) ? valor : valor.toFixed(2).replace('.', ',');
}

export function criarFormatador(stationData) {
  const currencyData = {
    currency_multiplier: stationData?.currency_multiplier,
    currency_name: stationData?.currency_name,
    currency_name_position: stationData?.currency_name_position,
  };
  if (!currencyData.currency_name || currencyData.currency_multiplier == null) {
    return (valor) => `${formatPoints(valor)} pts`;
  }
  return (valor) => customCurrencyChanger(currencyData, valor);
}
